function IconChevronRight() {
  return (
    <svg viewBox="0 0 30 30" width={30} height={30}>
      <path d="M10,27,22,15,10,3" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
    </svg>
  );
}

export default IconChevronRight;
